export const AllegatoTipo = Object.freeze({
  RICETTA: "RICETTA",
  FOTO: "FOTO",
  BARCODE: "BARCODE",
  DOCUMENTO: "DOCUMENTO",
});

export const allegatoShape = {
  id: "",
  tipo: AllegatoTipo.RICETTA,
  nomeFile: "",
  url: "",
};

export const createAllegatoModel = (overrides = {}) => ({
  ...allegatoShape,
  ...overrides,
});

